import { ITypeRequest } from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import useMyWorkspacesChildren from '../../../../../../../../redux/workspace/hooks/useMyWorkspacesChildren';
import { useMemo } from 'react';
import useMultipleQueries from '../../../../../../../../shared/util/rtk/useQueries';
import StructureAPI from '../../../../../../../../redux/structure/StructureAPI';
import { FlexeserveGroupStructure } from '../../../../../../../../redux/structure/GroupsAdapter';

type Data = FlexeserveGroupStructure & {
  businessUnits: string[];
  regions: string[];
  districts: string[];
  stores: string[];
  commanderIds: string[];
};
interface IUseStructuresWorkspacesProps {
  typeRequest: ITypeRequest;
}
function useStructuresWorkspaces(props: IUseStructuresWorkspacesProps) {
  const { typeRequest } = props;

  const { data } = useMyWorkspacesChildren({
    skip: typeRequest !== 'workspaces',
  });
  const keysWorkspaces = useMemo(() => Object.keys(data || {}), [data]);

  const structures = useMultipleQueries<Data, string>(
    StructureAPI.endpoints.getStructureV2,
    keysWorkspaces,
    {
      skip: !keysWorkspaces?.length,
    }
  );

  return structures;
}

export default useStructuresWorkspaces;
